import React from "react";
import { Link } from "react-router-dom";
import notFound from "../../images/not-found.png";

const Error = () => {
  return (
    <>
      <img
        style={{ width: "100%", height: "100vh", objectFit: "contain" }}
        src={notFound}
        alt="Not Found"
      />
      <div className="back-btn">
        <Link to="/">
          <button
            style={{
              position: "absolute",
              bottom: "25px",
              left: "50%",
              transform: "translateX(-50%)",
              padding: "10px 32px",
              borderRadius: "25px",
              background: "#FFC626",
              color: "#FFFFFF",
            }}
          >
            GO BACK
          </button>
        </Link>
      </div>
    </>
  );
};

export default Error;
